import { Controller } from "@hotwired/stimulus"
import { forgetDeferredCell, requestDeferredCell } from "../utils/deferred_cells"

// Une cellule d'index dont la valeur est calculée par le serveur, par lot (cf.
// Shared::DeferredCellComponent et utils/deferred_cells.ts). Le contrôleur n'envoie rien lui-même :
// il inscrit la cellule dans le lot de sa page. Le serveur la remplace ensuite par sa valeur, ce
// qui détache ce contrôleur.
export default class extends Controller {
  static values = { url: String, id: String, stream: String, lazy: { type: Boolean, default: true } }

  connect() {
    // Turbo affiche d'abord un aperçu issu de son cache : ne rien demander pour une page qui va
    // être remplacée à l'instant.
    if (document.documentElement.hasAttribute("data-turbo-preview")) return

    if (!this.lazyValue) return this.request()

    // Comme `loading: "lazy"` d'un turbo_frame : seules les lignes visibles (plus une marge) sont
    // demandées, ce qui borne le travail serveur sur les grandes listes.
    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return

      this.stopObserving()
      this.request()
    }, { rootMargin: "200px" })
    this.observer.observe(this.element)
  }

  request() {
    requestDeferredCell(this.element, { url: this.urlValue, stream: this.streamValue, id: this.idValue })
  }

  disconnect() {
    this.stopObserving()
    forgetDeferredCell(this.element)
  }

  stopObserving() {
    this.observer?.disconnect()
    this.observer = null
  }
}
